import gql from 'graphql-tag';

export const listUsersQuery = gql`
  query listUsers {
    listUsers {
      id
      username
      firstName
      lastName
      avatarUrl
      fullName
      emails {
        emailAddress
        emailType
        active
        isDeleted
        isPrimary
        isVerified
      }
      permissions {
        context
        actions
        resource
      }
      roles
      auth0Id
      timezone
      socialAccounts {
        userId
        provider
        connection
        isSocial
      }
    }
  }
`;
